import { useTranslation } from "react-i18next";

interface ProgressBarProps {
	step: number;
	totalSteps: number;
}

export function ProgressBar({ step, totalSteps }: ProgressBarProps) {
	const { t } = useTranslation("onboarding");
	const percentage = Math.round((step / totalSteps) * 100);

	return (
		<div className="flex items-center gap-3 text-sm text-foreground/50">
			<span className="font-medium">{t("step_of", { step, total: totalSteps })}</span>
			<div className="flex-1 h-2 bg-default-200 rounded-full overflow-hidden">
				<div className="h-full bg-accent rounded-full transition-all duration-300" style={{ width: `${percentage}%` }} />
			</div>
			<span>{percentage}%</span>
		</div>
	);
}
